// @flow
import React from 'react';
import { compose } from 'redux';
import { defineMessages } from 'react-intl';
import dataComponent from '../hoc/dataComponent';

import ConversionForm from '../components/premium/ConversionForm';

import { CHROME_CLEAN, META_TITLE_PREFIX } from '../constants';

import chromeComponent from '../hoc/chromeComponent';
import trackedViewComponent from '../hoc/trackedViewComponent';

import RedirectInstruction from '../lib/routing/RedirectInstruction';

import styles from './Subscribe.css';
import { PLEASE_WHILE_REDIRECTING } from '../lib/notifications';
import { connect } from 'react-redux';
import * as notificationsActions from '../actions/notifications';
import { selectUserIsPatron } from '../selectors/user';
import { selectSubscriptionFromId } from '../selectors/subscriptionOffer';
import * as clientActions from '../actions/client';
import { selectIsInIOSApp } from '../selectors/client';
import { getDeeplinkUrl } from '../lib/locale-utils';

declare var __CAPACITOR__: boolean;

type MapStateToProps = {
  isInIOSApp: boolean,
};

type DispatchProps = {
  addNotification: Function,
};

type Props = DispatchProps & MapStateToProps;

const messages = defineMessages({
  metaTitle: {
    id: 'subscribe.title',
    defaultMessage: 'Subscribe',
  },
});

const Subscribe = ({ addNotification, isInIOSApp }: Props) => {
  const onComplete = async () => {
    addNotification(PLEASE_WHILE_REDIRECTING);
    document.location.href = isInIOSApp ? getDeeplinkUrl('/discover?reloadUser=1') : '/discover';
  };

  const onClose = () => {
    document.location.href = isInIOSApp ? getDeeplinkUrl('/discover') : '/discover';
  };

  return (
    <div className={styles.wrapper}>
      <ConversionForm className={styles.form} onComplete={onComplete} onClose={onClose} />
    </div>
  );
};

Subscribe.onDataFetch = (store, params, location, intl) => {
  store.dispatch(
    clientActions.setHelmet({
      title: META_TITLE_PREFIX + intl.formatMessage(messages.metaTitle),
      canonicalRoute: '/subscribe',
    })
  );
};

function fetchData(store) {
  const state = store.getState();
  const shouldRedirect = selectUserIsPatron(state);
  if (shouldRedirect) {
    return Promise.reject(new RedirectInstruction('/discover'));
  }

  return [];
}

function mapStateToProps(state: Object): MapStateToProps {
  return {
    isInIOSApp: selectIsInIOSApp(state),
  };
}

const trackingProps = state => {
  return {
    landing_page_id: selectSubscriptionFromId(state),
  };
};

const dispatchProps: DispatchProps = {
  addNotification: notificationsActions.addNotification,
};

export default compose(
  connect(mapStateToProps, dispatchProps),
  trackedViewComponent('Subscribe', trackingProps),
  chromeComponent({ type: CHROME_CLEAN }),
  dataComponent(fetchData)
)(Subscribe);
